var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1239 15.4434L5.88086 11.1994L7.29486 9.78539L10.1239 12.6134L15.7799 6.95639L17.1949 8.37139L10.1239 15.4434Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.880859 4.12939C0.880859 3.06853 1.30229 2.05111 2.05243 1.30097C2.80258 0.550822 3.81999 0.129395 4.88086 0.129395H18.8809C19.9417 0.129395 20.9591 0.550822 21.7093 1.30097C22.4594 2.05111 22.8809 3.06853 22.8809 4.12939V18.1294C22.8809 19.1903 22.4594 20.2077 21.7093 20.9578C20.9591 21.708 19.9417 22.1294 18.8809 22.1294H4.88086C3.81999 22.1294 2.80258 21.708 2.05243 20.9578C1.30229 20.2077 0.880859 19.1903 0.880859 18.1294V4.12939ZM4.88086 2.12939H18.8809C19.4113 2.12939 19.92 2.34011 20.2951 2.71518C20.6701 3.09025 20.8809 3.59896 20.8809 4.12939V18.1294C20.8809 18.6598 20.6701 19.1685 20.2951 19.5436C19.92 19.9187 19.4113 20.1294 18.8809 20.1294H4.88086C4.35043 20.1294 3.84172 19.9187 3.46665 19.5436C3.09157 19.1685 2.88086 18.6598 2.88086 18.1294V4.12939C2.88086 3.59896 3.09157 3.09025 3.46665 2.71518C3.84172 2.34011 4.35043 2.12939 4.88086 2.12939Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGrey);
export default __webpack_public_path__ + "static/media/check_grey.4c997f5963c0e83b705ea68ccf94dac7.svg";
export { ForwardRef as ReactComponent };